import Record from '../Record'

export default class LoginCredentials extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	validation_schema = {
		account_name: [
			'required'
		],
		password: [
			'required'
		]
	}
}
